const ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz';

/** Short, URL-friendly random id (base36, 12 chars ≈ 62 bits). */
export function newId(len = 12): string {
  const bytes = new Uint8Array(len);
  crypto.getRandomValues(bytes);
  let out = '';
  for (let i = 0; i < len; i++) out += ALPHABET[bytes[i] % 36];
  return out;
}

/** Fractional ordering helper: a value strictly between a and b. */
export function between(a: number | undefined, b: number | undefined): number {
  if (a === undefined && b === undefined) return 1000;
  if (a === undefined) return (b as number) - 1000;
  if (b === undefined) return a + 1000;
  return (a + b) / 2;
}
